import { GridCellProps } from "@progress/kendo-react-grid";
import { NumericTextBoxCell } from "../../../../Layout/Grid/Cell/Default/NumericTextBoxCell";
import { ReadOnlyProps } from "../../../../Project/EditProject/ReadOnlyProps";

export function MaxStockQuantityCell({ isReadOnly, ...props }: GridCellProps & ReadOnlyProps) {
  const canEdit = props.dataItem?.Rc2Flag === true;

  return <NumericTextBoxCell {...props} editable={canEdit ?? false} isReadOnly={isReadOnly} />;
}
